// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsHistogram_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.22411 8.15048C8.56805 7.25294 8.84779 6.41965 9.08139 5.72379C9.12754 5.58631 9.17216 5.45339 9.21485 5.32722C9.26489 5.17933 9.31164 5.04297 9.35545 4.91754C9.41739 5.08466 9.48326 5.27049 9.5534 5.47641C10.0751 7.00818 10.7981 8.19196 11.9198 8.96615C13.035 9.73587 14.4015 10.0015 16 10.0015V8.00147C14.5985 8.00147 13.6988 7.76389 13.0559 7.32015C12.4195 6.88089 11.8925 6.14095 11.4466 4.83163C11.2605 4.28518 11.0881 3.82845 10.924 3.46226C10.7672 3.11243 10.5884 2.77616 10.369 2.52255C10.1615 2.28264 9.70528 1.88745 9.05642 2.03033C8.52571 2.14719 8.23343 2.56719 8.10877 2.76532C7.82166 3.22161 7.56882 3.95183 7.32034 4.68626C7.27535 4.81923 7.22936 4.9562 7.1821 5.09694C6.94857 5.7924 6.68403 6.58021 6.35654 7.43483C5.63909 9.30709 5.01268 10.4065 4.25737 11.0628C3.711 11.5376 3.02611 11.8391 2 11.9516L2 2.00146H0V14.0015H1C1.01475 14.0015 1.02947 14.0015 1.04417 14.0015H16V12.0015H6.14037C6.98905 11.0324 7.61836 9.73127 8.22411 8.15048Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsHistogram is a generated icon component.
 */
let IconRmsHistogram = IconRmsHistogram_1 = class IconRmsHistogram extends IconBaseElement {
    render() {
        return html `${IconRmsHistogram_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsHistogram.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconRmsHistogram = IconRmsHistogram_1 = __decorate([
    customElement('zui-icon-rms-histogram')
], IconRmsHistogram);
export { IconRmsHistogram };
